module.exports = __webpack_public_path__ + "static/monika_proba@x1-ba1decd68b91ca9fa82abf9d6b1d1aba.jpg";